"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LIST_SYSTEM_LANGS = void 0;
const react_1 = __importStar(require("react"));
const schema_1 = __importDefault(require("./schema"));
const dataTransferSchema_1 = __importDefault(require("./dataTransferSchema"));
const schemaComponents_1 = require("@/schemaComponents");
const models_hook_1 = require("app/models.hook");
const route_1 = require("../route");
const auth_1 = require("common/auth");
const project_1 = require("utils/project");
const index_1 = require("../../../index");
exports.LIST_SYSTEM_LANGS = route_1.SYSTEM_LANGS.sub("/list", Langs);
function Langs() {
    const { role } = (0, auth_1.useAdminPageAuthorization)();
    const isMaster = role === "master";
    const { conditionSelector, condition } = (0, schemaComponents_1.useConditionSelector)({
        schema: (0, dataTransferSchema_1.default)(),
        hideTimeCondition: true,
    });
    const { list, loading, upsert, get } = (0, models_hook_1.useSystemLangList)({
        condition,
    });
    const parameter = (0, react_1.useMemo)(() => ({
        title: "言語一覧",
        edit: {
            path: ({ langId }) => (0, index_1.resolveRoute)("UPDATE_SYSTEM_LANG", { langId }),
        },
        create: {
            path: () => (0, index_1.resolveRoute)("ADD_SYSTEM_LANG", {}, {
                searchParams: { edit: "1" },
            }),
            isDisabled: !isMaster,
        },
        schema: (0, schema_1.default)(),
        download: {
            schema: isMaster ? (0, dataTransferSchema_1.default)() : (0, schema_1.default)(),
            handler: get,
            filename: `system-langs`,
        },
    }), [project_1.projectId]);
    return (react_1.default.createElement(schemaComponents_1.SchemaListPage, { parameter: parameter, list: list, loading: loading, header: conditionSelector }));
}
exports.default = Langs;
